import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Companies from "@/pages/Companies";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";
import LegalPage from "@/pages/LegalPage";
import FitKeyPage from "@/pages/FitKeyPage";
import SignIn from "@/pages/SignIn";
import Me from "@/pages/Me";
import { UNAUTHORIZED_EVENT } from "@/lib/session";

// No-login philosophy: the FitKey (Wallet pass) is the identity. Old account
// routes fall back to the check-in on the landing page.
const toCheckIn = <Navigate to="/#create-fitkey" replace />;

// Any private call that gets a 401 drops the token and lands on /signin.
function AuthRedirector() {
  const navigate = useNavigate();
  useEffect(() => {
    const go = () => {
      const here = window.location.pathname;
      if (here !== "/signin") navigate(`/signin?next=${encodeURIComponent(here)}`, { replace: true });
    };
    window.addEventListener(UNAUTHORIZED_EVENT, go);
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, go);
  }, [navigate]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthRedirector />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/k/:fitkeyId" element={<FitKeyPage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/me" element={<Me />} />
          <Route path="/auth/callback" element={toCheckIn} />
          <Route path="/login" element={<Navigate to="/signin" replace />} />
          <Route path="/signup" element={toCheckIn} />
          <Route path="/profile" element={<Navigate to="/me" replace />} />
          <Route path="/order-history" element={toCheckIn} />
          <Route path="/measurements" element={toCheckIn} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/legal/privacy"
            element={<LegalPage file="datenschutz.html" title="Datenschutzerklärung" testid="legal-privacy" />}
          />
          <Route
            path="/legal/imprint"
            element={<LegalPage file="impressum.html" title="Impressum" testid="legal-imprint" />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#FAFAFA",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "12px",
            fontFamily: "Satoshi, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
